module.exports = __webpack_public_path__ + "img/chat-quote.d5582be9.svg";